/** @jsxRuntime classic */

import React from 'react'
import { CommonSvgContent } from "./CommonSvgContent"
import { ContentLanding } from "./ContentLanding"
import {Link} from 'react-router-dom';

import "./../assets/scss/Landing.scss";


export const Landing = (props) => {
  let [openLogin, setOpenLogin] = React.useState(false);

  const loginRef = React.useRef();

  const handleToggleLogin = () => {
    setOpenLogin(!openLogin);
  }

  const stars = [];
  for (let i = 0; i < 60; i++) {
    stars.push(<div className="star" key={i}  />);
  }

  return(
    <div className="landing">
      {stars}

      <div className='logoMuseo'>
        <CommonSvgContent stringToRet="logoMuseo" />
      </div>

      <div className='collaborazione'>
        <p>In collaborazione con</p>
        <h3>INAF-Osservatorio<br />
        Astronomico<br />
        di Brera </h3>
      </div>

      <div className='agcom'>
        <ContentLanding stringToRet="agcom" />
      </div>
      <div className='soundon'>
        <ContentLanding stringToRet="soundon" />
      </div>

      <div className='logo'>
        <ContentLanding stringToRet="logo" />
        <h2>L'<strong>ESCAPE ROOM</strong> ONLINE PER SCOPRIRE I SEGRETI DI <strong>MARTE</strong></h2>
        <p className="introHome"><strong>La Terra è in pericolo. Abbiamo bisogno del tuo aiuto.</strong><br />
        Margherita Hacker, celebre astrofisica e appassionata di restauro di strumenti antichi,<br />ha rinvenuto un messaggio proveniente dal
        passato con un grave avvertimento per l’Umanità.<br />
        Marte nasconde una minaccia! <strong>Margherita Hacker sei tu.</strong><br />Riuscirai a salvare la Terra e l’umanità?</p>
      </div>

      <div className="mars">
        <ContentLanding stringToRet="mars" />
      </div>

      <div className="buttonsBlocks">
        <Link className="btn btn-danger" to="/scopri">scopri</Link>
        <a className="btn btn-warning" target="_blank" href="https://museoscienza.vivaticket.com/gift/ticketSale/tickets?category=W3GIFT">acquista</a>
        <button className="btn btn-success" onClick= {handleToggleLogin}>gioca</button>
      </div>


      <div className={`blockLogin ${openLogin ? "open" : ""}`} ref={loginRef}>
        {(props.loginfeedback === "empty") && (
          <div className="error"><p>TUTTI I CAMPI SONO OBBLIGATORI</p></div>
        )}
        {(props.loginfeedback === "code") && (
          <div className="error"><p>CONTROLLA IL CODICE INSERITO</p></div>
        )}
        <div className="blockWrapper">
          <div className="form">
            <div>
              <input maxLength="15" type="text" onChange={(e) => props.onChangeNick(e)} className="form-control" name="nickname" id="nickname" aria-describedby="emailHelp" placeholder="Nickname" value={props.nick} />
              <input type="text" onChange={(e) => props.onChangeTicket(e)} className="form-control" name="code" id="code" aria-describedby="emailHelp" placeholder="Code" value={props.ticket} />
            </div>
            <button type="submit" onClick= {() => props.onSubmitTicket()} className="btn btn-success">
              {(props.waiting === true) && ( <CommonSvgContent stringToRet="loading" /> )}
              {(props.waiting === false) && ( <>entra</> )}
            </button>

          </div>
        </div>
      </div>

      <div className="menuInline">
        <Link to="/classifica">classifica</Link>
        <Link to="/come-funziona">come funziona</Link>
        <Link to="/regolamento">termini e condizioni d'uso</Link>
        <Link to="/crediti">crediti</Link>
        <Link to="/contatti">contatti e assistenza</Link>
      </div>

    </div>
  )
}
